import React from 'react';
// @ts-expect-error
import Recaptcha from 'react-recaptcha';

import {assertAndContinue} from 'Asserts';
import BenchlingConfig from 'BenchlingConfig';
import EmailInput from 'onboarding/EmailInput';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {TagsInputSize} from 'ui-library/tags-input/TagsInputConstants';

interface EmailInviteProps {
  onInvite: (emails: Array<string>, recaptcha: string) => void;
  buttonSize: ButtonSize;
  emailChipSize: TagsInputSize;
}

interface State {
  emails: Array<string>;
  invitePending: boolean;
}

class EmailInvite extends React.Component<EmailInviteProps> {
  reCaptcha: Recaptcha | null = null;

  state: State = {
    emails: [],
    invitePending: false,
  };

  static defaultProps: Partial<EmailInviteProps> = {
    buttonSize: ButtonSize.LARGE,
    emailChipSize: TagsInputSize.LARGE,
  };

  UNSAFE_componentWillMount(): void {
    if (!document.getElementById('recaptcha-script')) {
      const script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
      script.id = 'recaptcha-script';
      document.body.appendChild(script);
    }
  }

  _reset(): void {
    if (this.reCaptcha) {
      this.reCaptcha.reset();
      this.reCaptcha.execute();
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleLoadRecaptcha = () => {
    if (this.state.invitePending) {
      this._reset();
    }
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleVerifyCallback = (recaptcha: string) => {
    if (this.state.invitePending) {
      this.props.onInvite(this.state.emails, recaptcha);
      this.setState({invitePending: false, emails: []});
    } else {
      assertAndContinue(false, 'Expecting invitePending to be true');
    }
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleInviteClicked = () => {
    this.setState({invitePending: true});
    this._reset();
  };

  render(): JSX.Element {
    return (
      <div className="u-spacing-top">
        <Recaptcha
          ref={(el: Recaptcha) => {
            this.reCaptcha = el;
          }}
          size="invisible"
          render="explicit"
          sitekey={BenchlingConfig.AUTH_RECAPTCHA_KEY}
          onloadCallback={this._handleLoadRecaptcha}
          verifyCallback={this._handleVerifyCallback}
          badge="bottomleft"
        />
        <div className="u-flex-display">
          <EmailInput
            emails={this.state.emails}
            onChangeEmails={(newEmails: Array<string>) => {
              this.setState({emails: newEmails});
            }}
            size={this.props.emailChipSize}
            focusOnMount={true}
          />
          <Button
            buttonStyle={ButtonStyle.PRIMARY}
            className="u-mini-spacing-left"
            onClick={this._handleInviteClicked}
            size={this.props.buttonSize}
            text="Invite"
            disabled={this.state.invitePending}
          />
        </div>
      </div>
    );
  }
}

export default EmailInvite;
